import { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Tooltip } from '@material-ui/core'
import { Upload } from 'react-feather'
import useSnackbar from 'hooks/useSnackbar'
import * as service from 'service'

const AccessButton = ({ paramsFilter }) => {
  const snackbar = useSnackbar()
  const [loading, setLoading] = useState(false)

  const handleSendAccessReport = async () => {
    setLoading(true)
    try {
      await service.dponet.companies.companiesListCsv({
        ...paramsFilter,
      })
      snackbar.open({
        message:
          'Sucesso! O relatório de acessos será enviado ao e-mail padrão.',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message: 'Erro ao solicitar relatório!',
        variant: 'error',
      })
    }
    setLoading(false)
  }

  return (
    <Tooltip title="Acessos">
      <span>
        <Button
          onClick={handleSendAccessReport}
          startIcon={<Upload size="18" />}
          variant="contained"
          color="primary"
          disabled={loading}
        >
          Acessos
        </Button>
      </span>
    </Tooltip>
  )
}

AccessButton.propTypes = {
  paramsFilter: PropTypes.object,
}

export default AccessButton
